import React, { useState, useEffect } from "react";
import { GoogleMap, Marker, InfoWindow, useLoadScript } from "@react-google-maps/api";
import MetaData from "../layout/MetaData";
import { useGetUserDetailsQuery } from "../../redux/api/userApi";
import "../../css/Admin.css";
import Loader from "../layout/Loader";
import { useParams } from "react-router-dom";
import "../../css/Driver.css";

const UserLocation = () => {
  const params = useParams();
  const { data, isLoading } = useGetUserDetailsQuery(params?.id);
  const user = data?.userDetail || {};
  const { name, email, phoneNo, latitude, longitude } = user;

  const [selectedLocation, setSelectedLocation] = useState(null);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  useEffect(() => {
    if (latitude && longitude) {
      setSelectedLocation({ lat: parseFloat(latitude), lng: parseFloat(longitude) });
    }
  }, [latitude, longitude]);

  if (isLoading) return <Loader />;
  if (!isLoaded) return <div>Loading Map...</div>;

  return (
    <>
      <MetaData title="User Location" />
      <div className="row d-flex justify-content-around">
        <div className="col-12 col-lg-9 order-details">
          <h3 className="mt-5 mb-3">Location Details</h3>

          <div className="card mb-4">
            <table className="table mb-0">
              <tbody>
                <tr>
                  <th scope="row">Latitude</th>
                  <td>{latitude || "Not Available"}</td>
                </tr>
                <tr>
                  <th scope="row">Longitude</th>
                  <td>{longitude || "Not Available"}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {latitude && longitude && (
            <div className="card mb-4" style={{ overflow: "hidden" }}>
              <GoogleMap
                mapContainerStyle={{ width: "100%", height: "400px" }}
                zoom={19}
                center={{ lat: parseFloat(latitude), lng: parseFloat(longitude) }}
                mapTypeId="roadmap"
                options={{ streetViewControl: false, mapTypeControl: false }}
              >
                <Marker
                  position={{ lat: parseFloat(latitude), lng: parseFloat(longitude) }}
                  onClick={() => setSelectedLocation({ lat: parseFloat(latitude), lng: parseFloat(longitude) })}
                />
                {selectedLocation && (
                  <InfoWindow position={selectedLocation} onCloseClick={() => setSelectedLocation(null)}>
                    <div>
                      <h6>{name}</h6>
                      <p className="mb-1">Email: {email || "No Email"}</p>
                      <p className="mb-0">Phone: {phoneNo ? `0${phoneNo}` : "Not Available"}</p>
                    </div>
                  </InfoWindow>
                )}
              </GoogleMap>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default UserLocation;